import PropTypes from "prop-types";
import classnamesBind from "classnames/bind";
import styles from "./StarRating.scss";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";

const classnames = classnamesBind.bind(styles);

export default function StarRating({ rating, large }) {
  const { getTranslation } = useRuntimeConstants();

  return (
    <div
      className={classnames({
        [styles.container]: !large,
        [styles.containerLarge]: large,
      })}
    >
      <div className={styles.starRating}>
        <p className={styles.screenreaderOnly}>
          {getTranslation("pdp_ratings_reviews_star_rating", {
            count: rating,
            smart_count: rating,
          })}
        </p>
        {[1, 2, 3, 4, 5].map((index) => {
          let className = "product-ratings-empty";
          if (index - rating <= 0) {
            className = "product-ratings-full";
          }
          if (index - rating === 0.5) {
            className = "product-ratings-half";
          }
          return (
            <span
              key={`star-${index}`}
              className={classnames(className, styles.star)}
              aria-hidden={true}
            />
          );
        })}
      </div>
    </div>
  );
}

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  large: PropTypes.bool,
};
